<template>
  <div data-component-group="comment-dialog" data-component="edit">
    <dialog-edit
      icon="mode_comment"
      :to="`/canned-replies/${activeComment?.id}`"
      :title="$t('edit_comment')"
      content-class="edit-comment-dialog"
      is-fullscreen
      :is-on="true"
      :on-close="onCancel"
    >
      <template v-slot:content>
        <forms-comment-edit
          :comment="activeComment"
          :is-loading="isEditingComment"
          :on-cancel="onCancel"
          :on-submit="canUpdateComment ? updateComment : undefined"
        />
      </template>
    </dialog-edit>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isEditingComment: false,
      };
    },
    created() {
      if (!this.activeComment?.id) {
        this.$store.dispatch('cannedReplies/getItem', { id: this.$route.params.id });
      }
    },
    computed: {
      activeComment() {
        return this.$store.getters['cannedReplies/activeItem'];
      },
      canUpdateComment() {
        return this.$store.getters['auth/isAuthorized']([{ subject: 'comment', actions: ['update'] }]);
      },
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'canned-replies' });
      },
      updateComment(comment) {
        if (!this.canUpdateComment) {
          return undefined;
        }

        const nextComment = {
          ...comment,
          id: this.activeComment.id,
        };

        this.isEditingComment = true;

        return this.$store
          .dispatch('cannedReplies/update', nextComment)
          .then((res) => {
            this.$router.push({ name: 'canned-replies', query: { status: 'success' } });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isEditingComment = false;
          });
      },
    },
  };
</script>
